// extracted by mini-css-extract-plugin
export default {"toastBody":"App_toastBody__W9Mv-","toastClassName":"App_toastClassName__cULUB"};